module.exports = __webpack_public_path__ + "img/VIDEO1.620b327a.png";